import React from 'react';
import { Formik } from 'formik';
import { Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import initialValues from './initialValues';
import BaseForm from './baseForm';
import Validation from './validation';
import DividerForm from '../UI/DividerForm';

import { SaveBtn } from '../../Buttons';

class DocumentoIdentita extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
    };
  }

  onSubmit = () => {
    this.baseForm.submitForm();
  }

  onBaseSubmit = (values, actions) => {
    actions.setSubmitting(true);

    const payload = {
      ...values,
      dataScadenza: values.dataScadenza.format('YYYY-MM-DD'),
      dataEmissione: values.dataEmissione.format('YYYY-MM-DD'),
      anagrafica: this.props.anagraficaId,
      ente: values.ente.value ? values.ente.value : values.ente,
      comune: values.comuneNascita || values.comune,
      provincia: values.provinciaNascita || values.provincia,
      tipoDocumento: values.tipoDocumento.value || values.tipoDocumento,
    };
    this.props.sendWithData(payload, this.props.onFiles);
  }

  render() {
    return (
      <Grid>
        <Grid.Column width={16}>
          <Formik
            ref={(c) => { this.baseForm = c; }}
            initialValues={this.props.initialValues ? this.props.initialValues : initialValues}
            onSubmit={this.onBaseSubmit}
            validate={Validation}
            render={(props) => (<BaseForm {...props} />)}
          />
        </Grid.Column>
        <DividerForm />
        <Grid.Column width={8} textAlign="left">
          <Button onClick={this.props.close} type="button" icon="delete" labelPosition="right" content="Chiudi" />
        </Grid.Column>
        <Grid.Column width={8} textAlign="right">
          <SaveBtn action={this.onSubmit} />
        </Grid.Column>
      </Grid>
    );
  }
}

DocumentoIdentita.propTypes = {
  initialValues: PropTypes.object,
  // onEdit: PropTypes.func,
  // notifications: PropTypes.object,
  // update: PropTypes.func,
  close: PropTypes.func,
  onFiles: PropTypes.func,
  sendWithData: PropTypes.func,
  anagraficaId: PropTypes.string,
};

export default DocumentoIdentita;



// WEBPACK FOOTER //
// ./app/components/Forms/DocumentoIdentita/index.js